import React from 'react';
import GroupCard from './GroupCard';
import NewGroupAdder from './NewGroupAdder';
import { groupByValue } from './utils';

interface GroupedCardListProps {
  sectionType: 'alias_map' | 'hearing_corrections';
  data: Record<string, string>;
  onAdd: (key: string, value: string) => void;
  onRemove: (key: string) => void;
  menuItems?: Array<{ item_name: string }>;
}

const GroupedCardList: React.FC<GroupedCardListProps> = ({
  sectionType,
  data,
  onAdd,
  onRemove,
  menuItems,
}) => {
  const groups = groupByValue(data);
  const isAlias = sectionType === 'alias_map';
  const chipColor = isAlias ? 'green' : 'blue';
  const addPlaceholder = isAlias ? 'Type alias...' : 'Type misheard word...';

  if (groups.length === 0) {
    return (
      <div>
        <p className="text-xs text-gray-400 italic mb-2">
          {isAlias
            ? 'No aliases yet. Use the AI Generator above or add manually.'
            : 'No hearing corrections yet. Use the AI Generator above or add manually.'}
        </p>
        <NewGroupAdder sectionType={sectionType} onAdd={onAdd} menuItems={menuItems} />
      </div>
    );
  }

  return (
    <div>
      {groups.map(([target, triggers]) => (
        <GroupCard
          key={target}
          headerLabel={target}
          triggers={triggers}
          onRemoveTrigger={onRemove}
          onAddTrigger={onAdd}
          chipColor={chipColor}
          addPlaceholder={addPlaceholder}
        />
      ))}
      <NewGroupAdder sectionType={sectionType} onAdd={onAdd} menuItems={menuItems} />
    </div>
  );
};

export default GroupedCardList;
